import { Time } from '@biteinc/helpers';

type MagicCopyJobResult = {
  sourceLocation: string;
  attributes: string[];
  successfulLocations: string[];
  errors?: { location: string; message: string }[];
  warnings?: { title: string; message: string }[];
};

export function parseMagicCopyResults(results: MagicCopyJobResult[]): string {
  if (!results.length) {
    throw new Error('Missing magic copy job results.');
  }

  const successfulLocations: string[] = [];
  const warnings: string[] = [];
  const errors: string[] = [];

  results.forEach((result) => {
    successfulLocations.push(...result.successfulLocations);

    result.errors?.forEach((error) => {
      errors.push(`${error.location}: ${error.message}`);
    });
    result.warnings?.forEach((warning) => {
      warnings.push(`${warning.title}: ${warning.message}`);
    });
  });

  let text = 'Magic Copy Results\n\n';
  text += `Source Location: ${results[0].sourceLocation}\n\n`;

  text += `Attributes:\n`;
  results[0].attributes.forEach((attribute) => {
    text += `  - ${attribute}\n`;
  });
  text += '\n';

  if (warnings.length) {
    text += 'Warnings:\n';
    warnings.forEach((warning) => {
      text += `  - ${warning}\n`;
    });
    text += '\n';
  }

  if (successfulLocations.length) {
    text += 'Successfully magic copied to the following locations:\n';
    successfulLocations.forEach((location) => {
      text += `  - ${location}\n`;
    });
    text += '\n';
  } else {
    text += 'No locations were successfully magic copied to.\n\n';
  }

  if (errors.length) {
    text += 'Failed to magic copy to the following locations:\n';
    errors.forEach((error) => {
      text += `  - ${error}\n`;
    });
    text += '\n';
  } else {
    text += 'No errors occurred.\n\n';
  }

  return text;
}

export function getMagicCopyTimeout(jobInfo: { timeout: number }[]): string {
  const timeoutSum = jobInfo.reduce((acc, job) => acc + job.timeout, 0);

  return `${Math.ceil(timeoutSum / Time.MINUTE)}`;
}
